import React, {useRef, useState, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import _ from "lodash";
import {
    Form,
    Table,
    notification,
    Card,
    Popconfirm,
    Tooltip,
} from "../../components/Elements/appUtils";
import {getToken} from "../../request";
// import Modal from "../../components/Elements/Modal";
import {Drawer} from "../../components/Elements/appUtils";
import {
    KotType,
    categoryType,
    subCategoryType,
} from "../../components/_utils/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {appAxios as axios} from "../../request";
import {deletedCategoryFxn, fetchCategory} from "./actions";
import {addCategoryUrl, updateCategoryUrl} from "./api";
import Image from "../../edit (1).png";
import {useDispatch} from "react-redux";
import {getMainMenuUrl} from "../mainmenu/api";
import {getMainCategoryUrl} from "../maincategory/api";
import EditCategory from "./editCategory";
import ReactDragListView from "react-drag-listview";

let filterInit = {
    name: "",
    mainCategory: "",
    categoryType: "",
};
const yesNoOptions = [
    {key: true, name: "Yes"},
    {key: false, name: "No"},
];

function AddCategory(props) {
    let tableRef = useRef();
    let [filter, setFilter] = useState(filterInit);
    let dispatch = useDispatch();

    // {new changes
    const [mainMenus, setMainMenus] = useState([]);
    const [mainCategories, setMainCategories] = useState([]);
    const [allMainCategories, setAllMainCategories] = useState([]);
    // new changes}
    const [categoryFile, setCategoryFile] = useState("");
    const [deleted, setDeleted] = useState("false");
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [editData, setEditData] = useState(null);
    const [showIndexModal, setShowIndexModal] = useState(false);
    const [updatedIndexes, setUpdatedIndexes] = useState({});
    const [indexSaveLoading, setIndexSaveLoading] = useState(false);
    const [indexModalData, setIndexModalData] = useState([]);

    const handleFileChange = (e) => {
        const file = e?.target?.files?.[0] || e?.files?.[0];
        setCategoryFile(file || "");
    console.log("SELECTED FILE:", file);
    };
    const navigate = useNavigate();

    const loadMainMenus = async () => {
        try {
            const res = await axios.get(getMainMenuUrl(), getToken());

            if (res.data.success) {
                setMainMenus(res.data.data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    // const loadAllMainCategories = async () => {
    //   try {
    //     const res = await axios.get(getMainCategoryUrl(), getToken());

    //     if (res.data.success) {
    //       setAllMainCategories(res.data.data);
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };
    const loadAllMainCategories = async () => {
        try {
            const res = await axios.get(getMainCategoryUrl(), getToken());

            if (res.data.success) {
                const realMainCategories = (res.data.data || []).filter(
                    (item) => item.source !== "legacy"
                );
                setAllMainCategories(realMainCategories);
            }
        } catch (err) {
            console.log(err);
        }
    };
    // const loadMainCategories = async (menuId) => {
    //   console.log("SELECTED MENU ID:", menuId);
    //   try {
    //     // If no menu selected → empty categories
    //     if (!menuId) {
    //       const res = await axios.get(getMainCategoryUrl(), getToken());

    //       if (res.data.success) {
    //         setMainCategories(res.data.data);
    //       }

    //       return;
    //     }

    //     const res = await axios.get(getMainCategoryUrl(), {
    //       ...getToken(),
    //       params: { mainMenuId: menuId },
    //     });

    //     if (res.data.success) {
    //       setMainCategories(res.data.data);
    //     }
    //   } catch (err) {
    //     console.log(err);
    //   }
    // };
    const loadMainCategories = async (menuId) => {
        console.log("SELECTED MENU ID:", menuId);
        try {
            if (!menuId) {
                setMainCategories([]);
                return;
            }

            const res = await axios.get(getMainCategoryUrl(), {
                ...getToken(),
                params: {mainMenuId: menuId},
            });

            if (res.data.success) {
                const realMainCategories = (res.data.data || []).filter(
                    (item) => item.source !== "legacy"
                );
                setMainCategories(realMainCategories);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(() => {
        loadMainMenus();
        loadAllMainCategories(); // for table mapping
    }, []);
    const handleSubmit = async (e) => {
        const {form} = props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {

            if (!err) {
                if (!valData.mainMenuId) {
                    notification.warning({message: "Please select Main Menu"});
                    return;
                }
                if (!valData.name) {
                    notification.warning({message: "Enter Name"});
                    return;

        }
                // valData.mainCategoryIndex = mainCategoryIndex;
                let fd = new FormData();
                fd.append("obj", JSON.stringify(valData));
                if (categoryFile && categoryFile.name) {
                    fd.append("categoryFile", categoryFile);
                }

                console.log(valData, 'valsdat')

                const response = await axios.post(addCategoryUrl(), fd, getToken());
                if (response.data.success) {
                    notification.success({
                        message: response.data.message || "Success",
                    });
                    // form.setFieldsValue({
                    //   name: "",
                    //   menu: undefined,
                    //   mainCategory: undefined,
                    // });
                    form.setFieldsValue({
                        name: "",
                        mainMenuId: undefined,
                        mainCategoryId: undefined,
                        gst: undefined,
                        discount: undefined,
                    });
                    setCategoryFile("");

                    tableRef.current.reload();
                } else {
                    notification.error({message: response.data.message});
                }
            }
        });
    };
    const handleDragEnd = (fromIndex, toIndex) => {
        const data = [...indexModalData];
        const item = data.splice(fromIndex, 1)[0];
        data.splice(toIndex, 0, item);

        const updatedData = data.map((item, index) => ({
            ...item,
            index: index + 1,
            originalIndex: item.originalIndex,
        }));

        setIndexModalData(updatedData);

        const updatedIndexMap = {};
        updatedData.forEach((item) => {
            updatedIndexMap[item._id] = item.index;
        });
        setUpdatedIndexes(updatedIndexMap);
    };
//   const apiRequest = (params) => {
//     return new Promise(async (resolve) => {
//       try {
//         if (filter.name) {
//           params.name = filter.name;
//         }
//         // if (filter.mainCategory) {
//         //   params.mainCategory = filter.mainCategory;
//         // }
//         if (filter.mainCategory) {
//   params.mainCategoryId = filter.mainCategory;
// }
//         if (filter.categoryType) {
//           params.categoryType = filter.categoryType;
//         }
//         if (filter.subCategoryType) {
//           params.subCategoryType = filter.subCategoryType;
//         }
//        if (deleted === "true") {
//   params.deleted = true;
//   params.page = 1;
// } else {
//   params.deleted = { $ne: true };
// }
//         const data = await fetchCategory({ ...params });
//         console.log(data, "data");
//
//         setIndexModalData(
//             data?.data || data?.results || data?.docs || data?.rows || []
//         );
//
//         resolve(data);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     });
//   };
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            try {
                if (filter.name) {
                    params.name = filter.name;
                }
                if (filter.mainCategory) {
                    params.mainCategoryId = filter.mainCategory;
                }
                if (filter.categoryType) {
                    params.categoryType = filter.categoryType;
                }
                if (filter.subCategoryType) {
                    params.subCategoryType = filter.subCategoryType;
                }

                if (deleted === "true") {
                    params.deleted = true;
                    params.page = 1;
                } else {
                    params.deleted = {$ne: true};
                }

                const data = await fetchCategory({...params});
                resolve(data);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        });
    };

    let filterEvent = {
        _updateFilterState: (data) => {
            setFilter((prevState) => {
                return {
                    ...prevState,
                    ...data,
                };
            });
        },
    };

    const search = async () => {
        tableRef.current.reload();
    };
    const loadAllCategoriesForIndexModal = async () => {
        try {
            let params = {
                results: 1000, // or any big number
                page: 1,
                sortField: "index",
                sortOrder: "asc",
                deleted: {$ne: true},
            };

            // optional: if you still want filter by selected main category in modal
            if (filter.mainCategory) {
                params.mainCategoryId = filter.mainCategory;
            }

            const data = await fetchCategory(params);

            const fullList = data?.data || data?.results || data?.docs || data?.rows || [];

            const preparedData = fullList.map((item, idx) => ({
                ...item,
                index: item.index || idx + 1,
                originalIndex: item.index || idx + 1,
            }));

            setIndexModalData(preparedData);
            setUpdatedIndexes({});
            setShowIndexModal(true);
        } catch (error) {
            console.log("LOAD INDEX MODAL DATA ERROR:", error);
            notification.error({
                message: "Failed to load category order list",
            });
        }
    };
    // const openIndexModal = () => {
    //   const preparedData = (indexModalData || []).map((item) => ({
    //     ...item,
    //     originalIndex: item.index || 0,
    //   }));
    //
    //   setIndexModalData(preparedData);
    //   setUpdatedIndexes({});
    //   setShowIndexModal(true);
    // };
    const openIndexModal = async () => {
        await loadAllCategoriesForIndexModal();
    };
    const closeIndexModal = () => {
        setShowIndexModal(false);
        setUpdatedIndexes({});
    };
    const handleIndexChange = (id, value) => {
        setUpdatedIndexes((prev) => ({
            ...prev,
            [id]: value === "" ? "" : Number(value),
        }));
    };
    const handleSaveIndexes = async () => {
        try {
            setIndexSaveLoading(true);

            const categoryList = indexModalData || [];

            const finalIndexes = categoryList.map((item) => ({
                _id: item._id,
                name: item.name,
                index:
                    updatedIndexes[item._id] !== undefined
                        ? Number(updatedIndexes[item._id])
                        : Number(item.index || 0),
            }));

            const indexValues = finalIndexes.map((item) => item.index);
            const hasDuplicateIndex = indexValues.some(
                (val, i) => indexValues.indexOf(val) !== i
            );

            if (hasDuplicateIndex) {
                notification.error({
                    message: "Each category must have a unique index",
                });
                setIndexSaveLoading(false);
                return;
            }

            const promises = categoryList.map((item) => {
                const newIndex =
                    updatedIndexes[item._id] !== undefined
                        ? Number(updatedIndexes[item._id])
                        : Number(item.index || 0);

                // if (newIndex !== Number(item.index || 0)) {
                if (newIndex !== Number(item.originalIndex || 0)) {
                    const fd = new FormData();
                    fd.append(
                        "obj",
                        JSON.stringify({
                            _id: item._id,
                            index: newIndex,
                        })
                    );

                    return axios.post(updateCategoryUrl(), fd, getToken());
                }

                return null;
            });

            await Promise.all(promises.filter(Boolean));

            notification.success({
                message: "Indexes updated successfully",
            });

            closeIndexModal();
            tableRef.current.reload();
        } catch (error) {
            console.log("INDEX UPDATE ERROR:", error);
            console.log("ERROR RESPONSE DATA:", error?.response?.data);
            console.log("ERROR STATUS:", error?.response?.status);

            notification.error({
                message: error?.response?.data?.message || "Failed to update indexes",
            });
        } finally {
            setIndexSaveLoading(false);
        }
    };
    const handleEdit = (item) => {
        setEditData(item);
        setDrawerOpen(true);
    };

    const closeDrawer = () => {
        setDrawerOpen(false);
        setEditData(null);
    };
    const dragProps = {
        onDragEnd: handleDragEnd,
        nodeSelector: "tr",
        handleSelector: ".drag-handle",
    };
    const columns = [
        {
            title: "Main Menu",
            dataIndex: "mainMenuId",
            key: "mainMenuId",
            render: (text, record) => {
                const value = text?.mainMenuName
                return value
            },
        },
        {
            title: "Main Category",
            dataIndex: "mainCategoryId",
            key: "mainCategoryId",
            render: (text, record) => {
                const value = text?.mainCategoryName;
                return value
            },
        },
        {
            title: "Index",
            dataIndex: "index",
            key: "index",
            render: (text) => text ?? 0,
        },
        {
            title: "Category Name",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "GST",
            dataIndex: "gst",
            render: (text) => (text ? "Yes" : "No"),
        },
        {
            title: "Discount",
            dataIndex: "discount",
            render: (text) => (text ? "Yes" : "No"),
        },
        {
            title: "Category Type",
            dataIndex: "categoryType",
            key: "categoryType",
        },
        {
            title: "Sub Category",
            dataIndex: "subCategory",
            key: "subCategory",
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (v, item) => {
                return (
                    <>
                        {/*<a*/}
                        {/*  onClick={() => {*/}
                        {/*    navigate(`/editCategory?_id=${item._id}`);*/}
                        {/*  }}*/}
                        {/*>*/}
                        {/*  <img src={Image} style={{ height: "20px", width: "20px" }} />*/}
                        {/*</a>*/}
                        <a
                            onClick={() => {
                                handleEdit(item);
                            }}
                        >
                            <img src={Image} style={{height: "20px", width: "20px"}}/>
                        </a>
                        {item.deleted != true ? (
                            <Tooltip title={"Delete"}>
                                <Popconfirm
                                    title={"Are your sure, you want to Delete Category?"}
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => {
                                        deleteCategory(item._id, true);
                                    }}
                                >
                                    <i
                                        style={{
                                            height: "20px",
                                            width: "20px",
                                            marginLeft: "20px",
                                        }}
                                        className={"fa fa-trash far"}
                                    />
                                </Popconfirm>
                            </Tooltip>
                        ) : (
                            <Tooltip title={"Undo Delete"}>
                                <Popconfirm
                                    title={"Are your sure, you want to Undo Delete Category ?"}
                                    okText="Yes"
                                    cancelText="No"
                                    onConfirm={() => {
                                        deleteCategory(item._id, false);
                                    }}
                                >
                                    <i
                                        style={{
                                            height: "20px",
                                            width: "20px",
                                            marginLeft: "20px",
                                        }}
                                        className={"fa fa-undo far"}
                                    />
                                </Popconfirm>
                            </Tooltip>
                        )}
                    </>
                );
            },
        },
    ];
    let inputTypes = {
        fields: [
            {
                key: "mainMenuId",
                label: "Main Menu",
                span: "col-md-3",
                type: "select",
                required: true,
                options: mainMenus,
                keyAccessor: (x) => x._id,
                valueAccessor: (x) => x.mainMenuName.toUpperCase(),
                // onChange: (value) => {
                //   props.form.setFieldsValue({
                //     mainMenuId: value,
                //     mainCategory: undefined,
                //   });

                //   loadMainCategories(value);
                // },
                onChange: (value) => {
                    props.form.setFieldsValue({
                        mainMenuId: value,
                        mainCategoryId: undefined,
                    });

                    loadMainCategories(value);
                },
            },
            {
                key: "mainCategoryId",
                label: "Main Category",
                span: "col-md-3",
                type: "select",
                required: true,
                options: mainCategories,
                keyAccessor: (x) => x._id,
                // valueAccessor: (x) => x.mainCategoryName,
                valueAccessor: (x) => x.mainCategoryName?.toUpperCase(),
                onChange: (value) => {
                    props.form.setFieldsValue({
                        mainCategoryId: value,
                    });
                },
            },
            {
                key: "name",
                label: "Name *",
                span: "col-md-3",
                required: true,
            },
            {
                key: "gst",
                label: "GST",
                span: "col-md-3",
                type: "select",
                required: true,
                options: yesNoOptions,
                keyAccessor: (x) => x.key,
                valueAccessor: (x) => x.name,
                onChange: (value) => {
                    props.form.setFieldsValue({
                        gst: value,
                    });
                },
            },

            {
                key: "categoryType",
                label: "Category type",
                span: "col-md-3",
                type: "select",
                required: true,
                options: KotType,
                keyAccessor: (x) => x.key,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        categoryType: x,
                    });
                },

            },
            {
                key: "discount",
                label: "Discount",
                span: "col-md-3",
                type: "select",
                required: true,
                options: yesNoOptions,
                keyAccessor: (x) => x.key,
                valueAccessor: (x) => x.name,
                onChange: (value) => {
                    props.form.setFieldsValue({
                        discount: value,
                    });
                },
            },
            {
                key: "subCategory",
                label: "Sub Category",
                span: "col-md-3",
                type: "select",
                options: subCategoryType,
                hidden: !(props.form.getFieldValue("categoryType") == "kitchen"),
                required: props.form.getFieldValue("categoryType") == "kitchen",
                keyAccessor: (x) => x.key,
                valueAccessor: (x) => `${x.name}`,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        subCategory: x,
                    });
                },
            },
            {
                key: "categoryFile",
                label: "Category File",
                required: false,
                type: "file",
                fileName: categoryFile,
                //onChange: ({target}) => {
                  //   handleFileChange(target);
        // },
        onChange: (e) => {
          handleFileChange(e);
                },
                span: "col-md-3",
            },
        ],
    };

    // const deleteCategory = async (id, deleted) => {
    //   let data = {};
    //   data.id = id;
    //   data.deleted = deleted;
    //   let resp = await dispatch(deletedCategoryFxn(data));
    //   if (resp && resp.success) {
    //     tableRef.current.reload();
    //   }
    // };

    const deleteCategory = async (id, deleted) => {
        let data = {};
        data.id = id;
        data.deleted = deleted;

        let resp = await dispatch(deletedCategoryFxn(data));

        if (resp && resp.success) {
            notification.success({
                message: resp.message || "Deleted successfully",
            });
            tableRef.current.reload();
        } else {
            notification.error({
                message: resp?.message || "Delete failed",
            });
        }
    };
    return (
        <PageHeader title={"Categories"}>
            <Form onSubmit={handleSubmit}>
                <div className="form-elements-wrapper">
                    <div className="card-body">
                        <div className="row" style={{position: "relative"}}>
                            {/* MAIN CATEGORY FIELD */}
                            {/* MAIN MENU DROPDOWN WITH ADD ICON */}

                            <div
                                className="col-md-3"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <div style={{flex: 1}}>
                                    <GetEachFormFields
                                        {...props.form}
                                        item={inputTypes.fields[0]}
                                    />
                                </div>

                                {/* ADD MENU ICON */}
                                <i
                                    className="fa fa-plus-circle"
                                    title="Add Menu"
                                    style={{
                                        fontSize: "18px",
                                        cursor: "pointer",
                                        marginTop: "10px",
                                        color: "#007bff",
                                    }}
                                    onClick={() => navigate("/main-menu")}
                                />
                            </div>
                            {/* MAIN CATEGORY DROPDOWN WITH ADD ICON */}
                            <div
                                className="col-md-3"
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <div style={{flex: 1}}>
                                    <GetEachFormFields
                                        {...props.form}
                                        item={inputTypes.fields[1]}
                                    />
                                </div>

                                {/* ADD MAIN CATEGORY ICON */}
                                <i
                                    className="fa fa-plus-circle"
                                    title="Add Main Category"
                                    style={{
                                        fontSize: "18px",
                                        cursor: "pointer",
                                        marginTop: "10px",
                                        color: "#28a745",
                                    }}
                                    onClick={() => navigate("/main-category")}
                                />
                            </div>

                            {/* REST OF FIELDS */}
                            {inputTypes.fields.slice(2).map((item, key) =>
                                !item.hidden ? (
                                    <div className={item.span ? item.span : "col-md-6"} key={key}>
                                        <GetEachFormFields {...props.form} item={item}/>
                                    </div>
                                ) : null,
                            )}
                        </div>
                        <div className={"row"}>
                            <div className={"col-md-12"}>
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
            <div className="card-body">
                <div className="row mt-3">
                    <div className="col-lg-12 grid-margin stretch-card">
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <select
                                    className="form-control search-filters"
                                    onChange={(e) => {
                                        filterEvent._updateFilterState({
                                            mainCategory: e.target.value,
                                        });
                                    }}
                                    value={filter.mainCategory}
                                >
                                    <option value="">Choose Main Category</option>

                                    {allMainCategories &&
                                        allMainCategories.length > 0 &&
                                        allMainCategories.map((item) => (
                                            <option key={item._id} value={item._id}>
                                                {item.mainCategoryName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                            <div className="col-md-2">
                                <input
                                    type="text"
                                    className="form-control search-filters"
                                    name="name"
                                    placeholder="Search by Name"
                                    value={filter.name}
                                    onChange={(e) => {
                                        filterEvent._updateFilterState({name: e.target.value});
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <select
                                    className="form-control search-filters"
                                    onChange={(e) => {
                                        filterEvent._updateFilterState({
                                            categoryType: e.target.value,
                                        });
                                    }}
                                    value={filter.categoryType}
                                >
                                    <option value={""}>Choose Category Type</option>
                                    {KotType && KotType.length
                                        ? KotType.map((item) => {
                                            return (
                                                <option key={item.key} value={item.key}>
                                                    {item.name}
                                                </option>
                                            );
                                        })
                                        : null}
                                </select>
                            </div>
                            <div className="col-md-2">
                                <select
                                    className="form-control search-filters"
                                    onChange={(e) => {
                                        setDeleted(e.target.value);
                                        setTimeout(() => {
                                            tableRef.current.reload();
                                        }, 300);
                                    }}
                                    value={deleted}
                                >
                                    <option value={"false"}>Not Deleted</option>
                                    <option value={"true"}>Deleted</option>
                                </select>
                            </div>

                            <div className="col-md-2">
                                <div
                                    className="search-wrap"
                                    style={{display: "flex", gap: "10px", alignItems: "center"}}
                                >
                                    <button type="button" className="btn btn-info" onClick={search}>
                                        Search
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={openIndexModal}
                                    >
                                        Update Index
                                    </button>
                                </div>
                            </div>
                        </div>

                        <Card title={"Category List"}>
                            <Table apiRequest={apiRequest} columns={columns} ref={tableRef}/>
                        </Card>
                    </div>
                </div>
            </div>
            <EditCategory
                visible={drawerOpen}
                editData={editData}
                onClose={closeDrawer}
                reloadTable={() => {
                    tableRef.current.reload();
                }}

            />
            <Drawer
                title="Update Category Order"
                placement="right"
                onClose={closeIndexModal}
                visible={showIndexModal}
                width={'40%'}
                footer={(
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                            marginTop: "20px",
                        }}
                    >
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={closeIndexModal}
                        >
                            Cancel
                        </button>

                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleSaveIndexes}
                            disabled={indexSaveLoading}
                        >
                            {indexSaveLoading ? "Saving..." : "Save"}
                        </button>
                    </div>
                )}>
                <div className="container-fluid">
                    <ReactDragListView {...dragProps}>
                        <table className="table table-bordered">
                            <thead>
                            <tr>
                                <th style={{width: "60px"}}>Move</th>
                                <th>Category</th>
                                <th style={{width: "120px"}}>Index</th>
                            </tr>
                            </thead>
                            <tbody>
                            {indexModalData.map((item) => (
                                <tr key={item._id}>
                                    <td
                                        className="drag-handle"
                                        style={{cursor: "move", textAlign: "center"}}
                                    >
                                        <i className="fa fa-bars"/>
                                    </td>
                                    <td>{item.name}</td>
                                    <td>{updatedIndexes[item._id] ?? item.index ?? 0}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </ReactDragListView>


                </div>
            </Drawer>
        </PageHeader>
    );
}

export default Form.create()(AddCategory);
